// 顶部导航，跳转地址配置
// console.log(process.env.NODE_ENV)
const consoleUrl = {
  'development': 'http://127.0.0.1:8111',
  'testing': 'https://192.168.0.14/store/',
  'production': 'https://rpa.i-search.com.cn/store/',
  'uat': 'https://rpa.i-search.com.cn/store/'
}
const developerUrl = {
  'development': 'http://192.168.0.14:8000',
  'testing': 'https://192.168.0.14/developer',
  'production': 'https://rpa.i-search.com.cn/developer',
  'uat': 'https://rpa.i-search.com.cn/developer'
}
const workerOrderUrl = {
  'development': 'http://i-search.wicp.net:280/rpaWorkOrder?',
  'testing': 'http://i-search.wicp.net:280/rpaWorkOrder?',
  'production': 'http://support.i-search.com.cn/rpaWorkOrder?',
  'uat': 'http://support.i-search.com.cn/rpaWorkOrder?'
}
const SNSUrl = {
  'development': 'http://i-search.wicp.net:280/rpaSymLogin?',
  'testing': 'http://i-search.wicp.net:280/rpaSymLogin?',
  'production': 'http://support.i-search.com.cn/rpaSymLogin?',
  'uat': 'http://support.i-search.com.cn/rpaSymLogin?'
}
const jumpConfig = {
  console: consoleUrl[process.env.VUE_APP_CURRENTMODE],
  community: SNSUrl[process.env.VUE_APP_CURRENTMODE],
  documents: '#',
  // 开发者
  developer: developerUrl[process.env.VUE_APP_CURRENTMODE],
  // 工单
  workerOrder: workerOrderUrl[process.env.VUE_APP_CURRENTMODE]
}
export default jumpConfig
